import { createAction, props } from '@ngrx/store';

const GET_TEMPLATES = '[Templates] Get Templates';
const SET_TEMPLATES = '[Templates] Set Templates';
const CHANGE_DEFAULT_TEMPLATE = '[Templates] Change Default Template';
const GET_TEMPLATE_DATA = '[Templates] Get Template Data';
const SET_TEMPLATE_DATA = '[Templates] Set Template Data';
const REMOVE_TEMPLATE_DATA = '[Templates] Remove Template Data';
const SENT_TEMPLATES = '[Templates] Sent Templates';
const SAVE_TEMPLATES = '[Templates] Save Templates';
const UPDATE_TEMPLATES = '[Templates] Update Templates';
const DELETE_TEMPLATES = '[Templates] Delete Templates';

const getTemplates = createAction(GET_TEMPLATES, props<{ apiConstants: any }>());
const setTemplates = createAction(SET_TEMPLATES, props<{ templatesData: any }>());

const sentTemplates = createAction(SENT_TEMPLATES, props<{ apiConstants: any; saveTemplateData: any }>());

const saveTemplates = createAction(SAVE_TEMPLATES, props<{ templatesData: any }>());

const updateTemplates = createAction(UPDATE_TEMPLATES, props<{ templatesData: any }>());

const deleteTemplates = createAction(DELETE_TEMPLATES, props<{ templatesId: string }>());

const getTemplateData = createAction(GET_TEMPLATE_DATA, props<{ apiConstants: any; sid: string }>());

const setTemplateData = createAction(SET_TEMPLATE_DATA, props<{ templateData: any }>());

const removeTemplateData = createAction(REMOVE_TEMPLATE_DATA);

const changeDefaultTemplate = createAction(CHANGE_DEFAULT_TEMPLATE, props<{ apiConstants: any }>());

export {
  getTemplates,
  setTemplates,
  sentTemplates,
  saveTemplates,
  updateTemplates,
  deleteTemplates,
  getTemplateData,
  setTemplateData,
  removeTemplateData,
  changeDefaultTemplate
};
